/* eslint-disable no-unused-vars */
import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as rb from 'react-bootstrap';
import CountdownTimer from './Timer'
import moment from 'moment';

class CountdownBanner extends React.Component {
  constructor(props) {
    super();
    this.state = {
      scrolled: 0,
      apiUrl: window.$apiUrl,
      currentChallenge: "",
      isChallenge: ""
    };

  }

  getLatestChallenge() {
    fetch(this.state.apiUrl + '/ChallengeAPI/GetLatestChallenge', {
      method: 'POST',
      headers: {
        'token': process.env.REACT_APP_API_TOKEN,
        'Content-Type': 'application/json; charset=utf-8',
        'access-control-allow-origin': '*'
      }
    })
      .then(res => res.json())
      .then((data) => {
        this.setState({ isChallenge: data.Status });
        if (data.Status === 'OK') {
          this.setState({ currentChallenge: data });
        }

      })
      .catch(console.log);
  }

  componentDidMount() {
    this.getLatestChallenge();
  }

  render() {
    const { currentChallenge } = this.state;
    var ParticipantDate = false;
    const now = moment();
    if (moment(currentChallenge.Challenge_StartDate) < now && moment(currentChallenge.Challenge_EndDate) > now) {
      ParticipantDate = true;
    } else {
      ParticipantDate = false;
    }

    var endDate = moment(currentChallenge.Challenge_EndDate).format();
    return (
      <div className="CountdownBanner d-flex align-items-center py-3 py-md-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 p-0">
              <div className="countdownTitle h-100 position-relative d-flex align-items-center">
                <img src="images/slice/1.homepage/countdown/countdown-header.png" className="img-fluid" />
                {/* <div className="position-absolute text-light d-none d-md-block" style={{ transform: 'rotate(-1deg)', left: '8%', top: '67%' }}>
                  <small>Winner of the most liked story will be notified after the challenge has ended</small>
                </div> */}

              </div>
            </div>
            <div className="col-md-6 p-0">
              <div className="countdownTime py-5">
                <div className="d-flex justify-content-center">
                  <div className="text-center">
                    {ParticipantDate && currentChallenge && <p className="m-0 my-2 my-md-2 title-timer text-uppercase">{currentChallenge.Challenge_Title} ENDS IN:</p>}
                    {!ParticipantDate && currentChallenge && <p className="m-0 my-2 my-md-2 title-timer text-uppercase">{currentChallenge.Challenge_Title} HAS ENDED:</p>}
                    <CountdownTimer timeTillDate={endDate} timeFormat="" />
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* <div className="row d-md-none d-block">
            <div className="col-md-12 p-0">
              <div className="text-center mt-2 px-3 px-md-0 color_113F70 countdownTitle">
                <small>Winner of the most liked story will be notified after the challenge has ended</small>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

export default CountdownBanner;

